export default function appPersistenceHasLoaded(state) {
  return state.appPersistenceHasLoaded;
}
